import { AppLayout } from '@/layouts/AppLayout';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation } from 'react-router';

export function PaymentsLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const tabs = [
    { to: '/payments/audit', label: t('payments.tabs.audit') },
    { to: '/payments/batches', label: t('payments.tabs.batches') },
    { to: '/payments/escrow', label: t('payments.tabs.escrow') },
  ];

  return (
    <AppLayout breadcrumbs={[{ href: '/payments', children: t('payments.title') }]}>
      <nav className="border-b mb-4">
        <ul className="flex -mb-px text-sm font-medium">
          {tabs.map(({ to, label }) => (
            <li className="mr-4" key={to}>
              <Link
                to={to}
                className={cn(
                  'inline-block p-3 border-b-2 rounded-t-md',
                  pathname.startsWith(to)
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </AppLayout>
  );
}
